import React from 'react'

const Testimonial = () => {
    return (
        <div>
            {/* <!-- Testimonial 3 start --> */}
            <div className="testimonial-3">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="main-title">
                                <h1>Testimonios de clientes</h1>
                            </div>
                            <div id="carouselExampleIndicators3" className="carousel slide" data-ride="carousel">
                                <ol className="carousel-indicators">
                                    <li data-target="#carouselExampleIndicators3" data-slide-to="0" className="active"></li>
                                    <li data-target="#carouselExampleIndicators3" data-slide-to="1" className=""></li>
                                    <li data-target="#carouselExampleIndicators3" data-slide-to="2" className=""></li>
                                </ol>
                                <div className="carousel-inner">
                                    <div className="carousel-item active">
                                        <div className="testimonial-info">
                                            <div className="sz">
                                                <p>"Excelente servicio, muy amable y respetuoso!
                                                    100 % recomendado"</p>
                                            </div>
                                            <div className="media mb-4">
                                                <a className="pr-3" href="#">
                                                    <img src="https://firebasestorage.googleapis.com/v0/b/wti-services-jrz.appspot.com/o/clnt-01.png?alt=media&token=3aaada51-7f09-4762-a142-3becc8c3401d" alt="testimonial-3" className="img-fluid"/>
                                                </a>
                                                <div className="media-body align-self-center">
                                                    <h5>
                                                        <a href="#">Vanessa Prieto</a>
                                                    </h5>
                                                    <h6>Trabajadora</h6>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="carousel-item">
                                        <div className="testimonial-info">
                                            <div className="sz">
                                                <p>"Siempre encontrarás una sonrisa sincera, de primera entrada, te darán un servicio profesional 
                                                    excelente y profesional ya que están capacitados para brindarlo. 100% recomendado"</p>
                                            </div>
                                            <div className="media mb-4">
                                                <a className="pr-3" href="#">
                                                    <img src="https://firebasestorage.googleapis.com/v0/b/wti-services-jrz.appspot.com/o/clnt-02.png?alt=media&token=4b9605d2-2ea1-4eae-a3e2-2292110ef509" alt="testimonial-3" className="img-fluid"/>
                                                </a>
                                                <div className="media-body align-self-center">
                                                    <h5>
                                                        <a href="#">Rosalba Quiroz</a>
                                                    </h5>
                                                    <h6>Comerciante</h6>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="carousel-item">
                                        <div className="testimonial-info">
                                            <div className="sz">
                                                <p>"El proceso en linea es completamente FABULOSO. sin duda volvere a importar mi auto con WTI Services."</p>
                                            </div>
                                            <div className="media mb-4">
                                                <a className="pr-3" href="#">
                                                    <img src="https://firebasestorage.googleapis.com/v0/b/wti-services-jrz.appspot.com/o/clnt-03.png?alt=media&token=9bb34d49-2920-45e7-ac7f-2aa8151bbdfc" alt="testimonial-3" className="img-fluid"/>
                                                </a>
                                                <div className="media-body align-self-center">
                                                    <h5>
                                                        <a href="#">Rodrigo Almanza</a>
                                                    </h5>
                                                    <h6>Revendedor de autos</h6>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- Testimonial 3 end --> */}            
        </div>
    )
}

export default Testimonial


// WEBPACK FOOTER //
// ./src/components/Testimonial.jsx